import Vuetify from '../plugins/vuetify'

import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

import { dateFormat, dateLocales } from '@/plugins/dateLocales'
import { DangerousState } from '@/enum'
import { getUserTimezone } from '@/utils/timezone'


export const valueFormatted = (value, needFloat = false) => {
  const absValue = Math.abs(value)
  if (absValue === 0) {
    return value
  } else if (absValue >= 1.0 && !needFloat) {
    return value.toFixed(0)
  } else {
    return value.toFixed(3)
  }
}

export const distanceLocalized = (distance, postfix = true) => {
  if (postfix) {
    return `${valueFormatted(distance)} ${Vuetify.framework.lang.t('$vuetify.map.criticalPopup.sections.context.distance.postfix')}`
  } else {
    return `${valueFormatted(distance)}`
  }
}

export const durationLocalized = (duration, detailedSecondsMode = false) => {
  let result = ''
  let day, hour, minute, seconds
  seconds = Math.floor(duration / 1000)
  minute = Math.floor(seconds / 60)
  seconds = seconds % 60
  hour = Math.floor(minute / 60)
  minute = minute % 60
  day = Math.floor(hour / 24)
  hour = hour % 24

  if (!detailedSecondsMode) {
    if (seconds > 0 && hour === 0 && day === 0) {
      result = ` ${seconds} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.seconds')}` + result
    }

    if (minute > 0 && day === 0) {
      result = ` ${minute} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.minutes')}` + result
    }

    if (hour > 0) {
      result = ` ${hour} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.hours')}` + result
    }

    if (day > 0) {
      result = ` ${day} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.days')}` + result
    }

    if (result.trim() === '' && seconds === 0) {
      result = `0 ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.seconds')}`
    }
  } else {
    result = ` ${(duration / 1000).toFixed(2)} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.seconds')}` + result
  }

  return result.trim()
}

export const travelDateLocalized = (date) => {
  const timezone = getUserTimezone()
  const language = Vuetify.framework.lang.current
  if (timezone === null) {
    return format(date, dateFormat[language], { locale: dateLocales[language] })
  } else {
    return formatInTimeZone(date, timezone, dateFormat[language], { locale: dateLocales[language] })
  }

}

export const travelTimeLocalized = (date) => {
  return format(date, 'HH:mm:ss')
}

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const additionalTripStatisticsFilter = 200 // ms
export const userAdditionalTripStatisticsFiltersList = Object.values(DangerousState)
export const additionalTripStatisticsFilters = {
  //[DangerousState.DISTRACTION]: 0,
  [DangerousState.DISTRACTION_NO_ATTENTION]: 0,
  [DangerousState.DISTRACTION_NO_FACE]: 0,
  [DangerousState.DROWSINESS]: 200,
  [DangerousState.YAWNING]: 200,
  [DangerousState.BELT_NOT_FASTEN]: 0,
  [DangerousState.CAMERA_SABOTAGE]: 0,
  [DangerousState.EATING]: 0,
  [DangerousState.SMOKING]: 0,
  [DangerousState.CELLPHONE_USE]: 0
}
export const criticalEventAdditionalStatisticsFilters = {
  //[DangerousState.DISTRACTION]: 0,
  [DangerousState.DISTRACTION_NO_ATTENTION]: 0,
  [DangerousState.DISTRACTION_NO_FACE]: 0,
  [DangerousState.DROWSINESS]: 0,
  [DangerousState.YAWNING]: 0,
  [DangerousState.BELT_NOT_FASTEN]: 0,
  [DangerousState.CAMERA_SABOTAGE]: 0,
  [DangerousState.EATING]: 0,
  [DangerousState.SMOKING]: 0,
  [DangerousState.CELLPHONE_USE]: 0
}

export const criticalStatesColors = {
  retrainApproved: 'blue darken-2'
}
